import { Text } from '@mantine/core';
import { type CountdownRendererFn } from 'react-countdown';

const formatTime = (days: number, hours: number, minutes: number, seconds: number) => {
    const totalHours = days * 24 + hours;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${totalHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const OrderCountdownValue: CountdownRendererFn = ({ completed, days, hours, minutes, seconds }) => {
    if (completed) {
        return <Text>-</Text>;
    }

    return formatTime(days, hours, minutes, seconds);
};
